// STYLE
import './_blog-author.scss'

// LIBS
import React from 'react'
import {format} from 'date-fns'
import {sortBy, get, map} from 'lodash/fp'

// HELPERS
import {renderIf} from '../../lib/util.js'

// COMPONTENTS
import MetaData from '../../components/meta-data'
import BlogPostItem from '../../components/blog-post-item'
import AuthorMetaData from '../../components/author-metadata'

// INTERFACE
export const query = graphql`
  query BlogAuthor($slug: String!) {
    allBlogJson(filter: {blogAuthor: {fields: { slug: {eq: $slug }}}}) {
      edges {
        node {
          title
          metaDescription
          slug 
          createdAt
          blogAuthor {
            fields {
              name
              slug
            }
          }
          imageHeader {
            fields {
              file {
                url
              }
            }
          }
        }
      }
    }
    authorJson(slug: { eq: $slug}) {
      name
      slug
      twitter
      linkedIn
      website
      biography
      image {
        fields {
          description
          file {
            url
          }
        }
      }
    }
  }
`;

export default ({data}) => {
  let blogPosts = sortBy(item => new Date(item.createdAt), map(get('node'), get('allBlogJson.edges', data)))
  let {authorJson} = data

  return (
    <div className='blog-author' >
      <MetaData data={authorJson} />
      <AuthorMetaData authorJson={authorJson} />
        <div className='blog-author-posts'> 
          {blogPosts.reverse().map((node, i) => <BlogPostItem key={i} blogPost={node} />)}
        </div>
       <span className='clearfix' />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/templates/blog-author/index.js